module.exports = __webpack_public_path__ + "static/media/share.bdc2c49a.png";